import { useState } from "react";
import { FaqsDetail } from "./faqs-detail";
import { FaqsHistory } from "./faqs-history";
import { PageTabs } from "@/components/ui/page-tabs";

export const FaqsPage = () => {
  const [activeTab, setActiveTab] = useState<"detalles" | "historial">(
    "detalles",
  );

  return (
    <div className="w-full">
      {/* Tabs */}
      <PageTabs
        tabs={[
          { label: "Detalles", key: "detalles" },
          { label: "Historial", key: "historial" },
        ]}
        activeKey={activeTab}
        onTabChange={(key) => {
          setActiveTab(key as "detalles" | "historial");
        }}
        className="mb-4"
      ></PageTabs>
      {/* Contenido dinámico */}
      {activeTab === "detalles" ? <FaqsDetail /> : <FaqsHistory />}
    </div>
  );
};
